import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth-service/auth.service';
import { inject } from '@angular/core';

export const loginGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {

  const authService = inject(AuthService);
  const router = inject(Router);

  // Uses the same check as authGuard, so a stale localStorage profile can't
  // bounce the user between sign-in and the app.
  let loggedIn = false;
  try {
    loggedIn = await authService.hasActiveSession();
  } catch {
    loggedIn = false;
  }

  if (!loggedIn) {
    return true;
  }

  // Already signed in: send them into the app
  return router.createUrlTree(['/']);

}
